import { ImageSettingsTypes, ImageTypeEnum } from '../imageSettingsTypes';
import { ImageSettingsActionType } from './actions';
import { ImageSettingsActionListEnum } from './actionsTypes';
import { getItem } from '../../../helpers/localStorage';
import { LOCAL_STORAGE_IMAGE_SETTINGS } from '../../../constants/localStorageConstants';
import { IndentRedLineEnum } from '../../textSettings/textSettingsTypes';

const storageImageSettings = getItem<ImageSettingsTypes>(LOCAL_STORAGE_IMAGE_SETTINGS);

export const oldDefaultImageSettings = {
  imageType: ImageTypeEnum.CAGE,
  indentRight: 0,
  indentLeft: 8,
  indentTop: 5,
  indentRedLine: IndentRedLineEnum.CAGE,
  isDoublePage: false,
};

export const defaultImageSettings = {
  imageType: ImageTypeEnum.CAGE,
  indentRight: 0,
  indentLeft: 8,
  indentTop: 0,
  indentRedLine: IndentRedLineEnum.CAGE,
  isDoublePage: false,
};

export const initialStateImageSettings = {
  imageType: storageImageSettings?.imageType || oldDefaultImageSettings.imageType,
  indentRight: storageImageSettings ? storageImageSettings?.indentRight : oldDefaultImageSettings.indentRight,
  indentLeft: storageImageSettings ? storageImageSettings?.indentLeft : oldDefaultImageSettings.indentLeft,
  indentTop: storageImageSettings ? storageImageSettings?.indentTop : oldDefaultImageSettings.indentTop,
  indentRedLine: storageImageSettings ? storageImageSettings?.indentRedLine : oldDefaultImageSettings.indentRedLine,
  isDoublePage: storageImageSettings ? storageImageSettings.isDoublePage : oldDefaultImageSettings.isDoublePage,
};

const imageSettings = (state: ImageSettingsTypes = initialStateImageSettings, action: ImageSettingsActionType) => {
  if (action.type === ImageSettingsActionListEnum.CHANGE_IMAGE_TYPE) {
    return {
      ...state,
      imageType: action.imageType,
    };
  }

  if (action.type === ImageSettingsActionListEnum.RESET_IMAGE_SETTINGS) {
    return {
      ...state,
      ...action.imageSettings,
    };
  }

  if (action.type === ImageSettingsActionListEnum.CHANGE_INDENT_RIGHT) {
    return {
      ...state,
      indentRight: action.indentRight,
    };
  }

  if (action.type === ImageSettingsActionListEnum.CHANGE_INDENT_LEFT) {
    return {
      ...state,
      indentLeft: action.indentLeft,
    };
  }

  if (action.type === ImageSettingsActionListEnum.CHANGE_INDENT_TOP) {
    return {
      ...state,
      indentTop: action.indentTop,
    };
  }

  if (action.type === ImageSettingsActionListEnum.CHANGE_INDENT_RED_LINE) {
    return {
      ...state,
      indentRedLine: action.indentRedLine,
    };
  }

  if (action.type === ImageSettingsActionListEnum.TOGGLE_DOUBLE_PAGE) {
    return {
      ...state,
      isDoublePage: action.isDoublePage,
    };
  }

  return state;
};

export default imageSettings;
